module.exports = __webpack_public_path__ + "static/Sequence_Harmonize_Homepage-ee013ac5646f01560b40a35ddcb76149.mp4";